import { SearchOutlined } from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Card,
  Checkbox,
  Col,
  Row,
  Space,
  Typography,
} from "antd";
import { isEmpty } from "lodash";
import { findRelatedMedUser } from "modules/utilities/utility";
import React, { useEffect, useState } from "react";

const { Option } = AutoComplete;
const { Meta } = Card;
const { Text, Title } = Typography;

function TransMedRepSearch({
  searchValue,
  setSearchValue,
  searchData,
  setSearchData,
  setSelectedSearch,
  selectedSearch,
  targetUserLevel,
  selectedUserID,
  engagementData,
  medReps,
  selectedMedRep,
  setSelectedMedRep,
  setFilterAgents,
  setMessage,
}) {
  const [isResponse, setIsResponse] = useState(false);
  const [isCloseDropdown, setIsCloseDropdown] = useState(false);

  useEffect(() => {
    if (isEmpty(selectedSearch)) {
      setSelectedMedRep([]);
      setSearchValue("");
      setSearchData([]);
    }
  }, [selectedSearch]);

  useEffect(() => {
    setFilterAgents([]);
    setSelectedSearch({});
  }, [targetUserLevel, engagementData]);

  const handleClear = () => {
    setSearchValue("");
    setSelectedMedRep([]);
    setFilterAgents([]);
    setSelectedSearch({});
  };

  const handleSearch = async (event) => {
    setSearchValue(event);
    if (isEmpty(event)) setIsCloseDropdown(false);
  };

  const handleSubmit = async () => {
    setIsResponse(true);
    if (!isEmpty(medReps.userRole)) {
      let findRelatedItem = findRelatedMedUser(medReps, searchValue);

      setSearchData(findRelatedItem);
      setIsResponse(false);
      setIsCloseDropdown(true);
    } else {
      setMessage("No data availaible");
      setSearchData([]);
      setIsResponse(false);
    }
  };

  const onChange = (event, value) => {
    let medValue = selectedMedRep.findIndex((med) => med.id == value.user_id);
    let tempMedValue = selectedMedRep;
    if (medValue < 0) {
      if (event.target.checked) {
        tempMedValue.push({
          first_name: value?.user?.first_name,
          id: value?.user_id,
        });
        setSelectedMedRep(tempMedValue);
      }
    } else {
      if (!event.target.checked) {
        tempMedValue.splice(medValue, 1);
        setSelectedMedRep(tempMedValue);
      }
    }

    let targetArray = selectedMedRep?.map((med) => {
      return med?.id;
    });

    setSelectedSearch((curr) => {
      curr["target"] = targetArray;
      return { ...curr };
    });
  };

  return (
    <>
      <Row>
        <Col span={19}>
          <AutoComplete
            defaultActiveFirstOption={false}
            filterOption={false}
            onSearch={handleSearch}
            placeholder="Select Med Rep / Med Reps"
            notFoundContent={null}
            value={searchValue}
            open={isCloseDropdown}
            showSearch
            style={{ width: "100%" }}
            suffixIcon={<SearchOutlined />}
          >
            {!isEmpty(searchData) &&
              searchData.map((searchResult, index) => (
                <Option key={index} value={searchValue}>
                  <Card>
                    <Row>
                      <Col span={2}>
                        <Checkbox
                          checked={
                            selectedMedRep.findIndex(
                              (med) => med.id == searchResult.user_id
                            ) < 0
                              ? false
                              : true
                          }
                          onChange={(event) => onChange(event, searchResult)}
                        />
                      </Col>
                      <Col>
                        <Meta
                          title={`${searchResult?.user?.first_name}`}
                          description={
                            <>
                              <Space direction="vertical">
                                <Text>{searchResult?.user?.email}</Text>
                              </Space>
                            </>
                          }
                        />
                      </Col>
                    </Row>
                  </Card>
                </Option>
              ))}
          </AutoComplete>
          {!isEmpty(searchData) && isCloseDropdown && (
            <Card
              style={{
                posistion: "absolute",
                top:
                  searchData?.length == 1
                    ? 120
                    : searchData?.length == 2
                    ? 230
                    : 260,
                width: "100%",
                zIndex: 99,
              }}
              type="outer"
              title="Selection Done"
              extra={
                <Button
                  type="primary"
                  onClick={() => setIsCloseDropdown(false)}
                >
                  OK
                </Button>
              }
            />
          )}
        </Col>

        <Col span={4}>
          <Space>
            <Button
              style={{ marginLeft: "9px" }}
              icon={<SearchOutlined />}
              type="primary"
              onClick={() => {
                handleSubmit();
                setFilterAgents([]);
              }}
              disabled={isEmpty(searchValue)}
              loading={isResponse}
            />
            <Button onClick={handleClear} disabled={isEmpty(searchValue)}>
              Clear
            </Button>
          </Space>
        </Col>
      </Row>
    </>
  );
}
export default TransMedRepSearch;
